<script lang="ts">
  import { push } from 'svelte-spa-router';
  import Loading from '../etc/loader.svelte';
  import RepositoryFactory, { CONTRACT, HATENOHAMA, PAYINFO } from '../repositories/RepositoryFactory';
  import { loginUser } from '../components/auth/LoginUser';
  import Businesses from '../constants/Business';
  import type { GetContractResult } from '../repositories/contract';
  import { displayYm } from '../components/Util.svelte';

  const displayUserName = ((): string => {
    if ($loginUser.sei || $loginUser.mei) {
      return `${$loginUser.sei ?? ''} ${$loginUser.mei ?? ''}`;
    }
    return $loginUser.loginId;
  })();

  const displayBusinessName = ((): string => {
    if ($loginUser.businessCode === 'UMOBILE_D_ENECOM') {
      return 'メガ・エッグモバイル MySIM';
    }
    return Businesses.LOGIN_BUSINESSES.find((v) => v.code === $loginUser.businessCode).name;
  })();

  let contract: GetContractResult;
  let isPaymentInvalid = false;
  let expirationYm: string;
  let promise = getApi();

  async function getApi() {
    const contractRepository = RepositoryFactory[CONTRACT];
    const payinfoRepository = RepositoryFactory[PAYINFO];
    const hatenohamaRepository = RepositoryFactory[HATENOHAMA];

    await Promise.all([
      contractRepository.getContract(),
      payinfoRepository.getPaymentInvalid(),
      hatenohamaRepository.getSlnKaiindataExpiration()
    ])
      .then((res) => {
        contract = res[0];
        isPaymentInvalid = res[1].isPaymentInvalid;
        expirationYm = res[2] ? res[2].expirationYm : '';
      })
      .catch((error) => errorProcess(error));
    return contract;
  }

  const errorProcess = (error: any) => {
    if (error.response.status === 403) {
      alert('セッションが切れました。再度ログインしてください。');
      loginUser.logout();
      push('/login');
    } else {
      alert('エラーが発生しました。');
    }
  };

  // 有効期限切れ間近
  const isExpirationAlert = (targetYm: string) => {
    // 有効期限3ヶ月以内
    var alertYm = new Date();
    alertYm.setDate(1);
    alertYm.setMonth(alertYm.getMonth() + 3);
    return Number(targetYm) <= Number(displayYm(alertYm));
  };

  // 有効期限切れ
  const isExpired = (targetYm: string) => {
    var currentYm = new Date();
    currentYm.setDate(1);
    return Number(targetYm) < Number(displayYm(currentYm));
  };
</script>

{#await promise}
  <Loading />
{:then contract}
  <div class="shadow rounded-lg bg-gray-50 border-1 p-8 mb-10 border-t-4 border-green-400 h-72">
    <div class="flex flex-col">
      <div class="flex-auto flex flex-col mb-4">
        <div class="flex-1">
          <div>
            {displayUserName}さんこんにちは <br />
            こちらは{displayBusinessName}のマイページです
          </div>

          {#if contract.contractStatusCode === 'TERMINATED'}
            <div class="mt-5">
              契約いただいていたサービスはすでに解約されています。永らくのご利用ありがとうごいました。
              <br />
              マイページは解約月翌月までのご利用となりますので、ご了承ください。
            </div>
          {:else if isPaymentInvalid}
            <div class="warning">
              ご登録されているクレジットカードが無効となっています。
              <br /><br />
              契約者情報>>お支払い方法>>変更　より、有効なクレジットカードを登録しなおしてください。
              <br /><br />
              有効なクレジットカードを登録いただけなかった場合、ご契約を強制的に解約させていただくことになります。
            </div>
          {:else if expirationYm}
            {#if isExpired(expirationYm)}
              <div class="warning">
                ご登録のクレジットカードの有効期限がすでに過ぎています。
                <br /><br />
                直ちに、契約者情報>>お支払い方法>>変更 より、有効期限の長い他のクレジットカードを登録しなおしてください。
                <br /><br />
                有効なクレジットカードを登録いただけなかった場合、ご契約を強制的に解約させていただくことになります。
              </div>
            {:else if isExpirationAlert(expirationYm)}
              <div class="warning">
                ご登録のクレジットカードの有効期限が間もなく到来します。
                <br /><br />
                契約者情報>>お支払い方法>>変更 より、有効期限の長い他のクレジットカードを登録しなおしてください。
                <br /><br />
                有効なクレジットカードを登録いただけなかった場合、ご契約を強制的に解約させていただくことになります。
              </div>
            {/if}
          {/if}
        </div>
      </div>
    </div>
  </div>
{/await}

<style lang="postcss">
  .warning {
    @apply mt-5 text-sm text-red-600 font-bold;
  }
</style>
